<template>
<div>
  <span v-for="p, i in path" :key="i" class="subheading">
    <span v-if="i > 0"> / </span>
    <router-link
      :to="p.url"
      :tag="i < path.length - 1 ? 'a' : 'span'"
      :class="i < path.length - 1 ? 'crumb-link' : ''"
    >{{p.name.length > 15 ? p.name.slice(0, 15) + '...' : p.name}}</router-link>
  </span>
</div>
</template>

<script>
export default {
  data: () => ({
    path: [],
    dash: false
  }),
  beforeMount () {
    this.loadCrumbs()
  },
  methods: {
    loadCrumbs () {
      let p = this.$route.path.slice(1, this.$route.path.length).split('/')
      if (p[p.length - 1] === '') {
        p.pop()
      }
      for (let i = 0; i < p.length; i++) {
        let o = {
          name: '',
          url: '/',
          cursor: false
        }
        o.name += p[i]
        for (let j = 0; j <= i; j++) {
          o.url += p[j]
          if (j !== i) o.url += '/'
        }
        this.path.push({...o})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/general/Crumbs.vue